module.exports = __webpack_public_path__ + "media/images/flags/GM-1a0ecab9bd82472965427ed2cf6f10ac.svg";